<div class="h-[100vh] overflow-hidden flex flex-col w-full items-center bg-surface-0 p-[10rem]">
    <div class="flex flex-row w-[70rem] h-[35rem]  ">

        <div class="flex flex-1 flex-col gap-4 p-14 bg-surface-800 text-white items-center rounded-md">
             <h1 class="mt-20 text-5xl font-semibold text-center">Oups...</h1>
            <h1 class="text-3xl font-semibold text-center">Le service a rencontré un problème</h1>
            <div class="grow"></div>
            <a href="https://logick.co">
                <img alt="Logick Logo" class="w-[6rem]" src="/img/logo-white.svg" />
            </a>
            <div class="text-xl font-light">La solution de billetterie au quotidien</div>
        </div>

        <div class="flex flex-1 flex-col gap-6 p-14" >
            <h1 class="text-3xl ">Que voulez-vous faire ?</h1>
            
            <p-button type="submit" label="Se re-connecter" [fluid]="true" [routerLink]="'/login'" />
            <p-button type="submit" label="Contacter le support" [fluid]="true" [outlined]="true" [routerLink]="'/login'" />
            
        </div>
    </div>
</div>